/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation, StringScalar, IntScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar, ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  uuid: string;
  url?: string;
  typeUrl?: string;
  order?: number;
  validCheck?: ValidType;
}>;

export const UpdateMetadataUrl = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar />} value={option.uuid} />;
  const $url = <Variable name="url" scalar={<StringScalar />} value={option.url} />;
  const $typeUrl = <Variable name="type_url" scalar={<StringScalar isNullable={true} />} value={option.typeUrl} />;
  const $validCheck = <Variable name="valid_check" scalar={<ValidTypeScalar value={option.validCheck} isNullable />} />;
  const $order = <Variable name="order" scalar={<IntScalar isNullable />} value={option.order} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_METADATA_URL">
      <SelectionSet
        name="updateMetadata_url"
        alias="updateMetadataUrl"
        argument={{
          where: {
            id: $uuid
          },
          data: {
            url: $url,
            type_url: $typeUrl,
            valid_check: $validCheck,
            exposure_order: $order
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    updateMetadataUrl: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
